module.exports = __webpack_public_path__ + "static/img/operation.a4e2091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operation.png
// module id = I2wR
// module chunks = 9